import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type React from 'react';

import { ContactButton } from '../../../components/UI/Buttons';

const ContactUs: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        my: 6,
        padding: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 4,
          py: 6,
        }}
      >
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{
            color: 'primaryDark.main',
            fontWeight: 600,
            mb: 2,
          }}
        >
          Empieza a usar Relif
        </Typography>

        <Typography
          variant="h6"
          align="center"
          sx={{
            color: 'primaryDark.main',
            mb: 4,
          }}
        >
          Solicita una demo y descubre cómo Relif puede ayudarte a mejorar tus ventas.
        </Typography>

        <ContactButton
          variant="contained"
          size="large"
          onClick={() => window.open('https://zcal.co/i/O1PPkO_D', '_blank', 'noopener,noreferrer')}
        >
          Habla con nosotros
        </ContactButton>
      </Box>
    </Box>
  );
};

export default ContactUs;
